<template>
    <span @click.alt.self="changeTranslation($event)">
        {{ translated }}
    </span>
</template>
<script setup>

import { translate } from './Translation';
import { computed } from 'vue';
import { can, cannot } from '../../helpers/General';
import { useStore } from 'vuex';
import { useLanguageStore } from '../../pinia/LanguageStore';
const store = useStore();

const props = defineProps({
    ident: {
        type: String,
        required: true,
    },
    parameters: {
        type: Object,
        required: false,
        default: {},
    }
})
const languageStore = useLanguageStore();

const translated = computed(() => {
    if (props.ident) {
        return translate(props.ident, props.parameters)
    }
    return props.ident;
});

function changeTranslation(event) {
    if (!event.altKey || cannot("labels.change")) {
        return;
    }
    window.emitter.emit("translations:change", {
        ident: props.ident,
        params: props.parameters,
    })
}
</script>
